import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  信息新增
export function goodsAdd (data) {
  return request({
    url: baseURL + 'goods/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function goodsList (data) {
  return request({
    url: baseURL + 'goods/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function goodsDelete (data) {
  return request({
    url: baseURL + 'goods/delete',
    method: 'post',
    data: data
  })
}
//  信息删除
export function goodsUpdate (data) {
  return request({
    url: baseURL + 'goods/update',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/goods/index.js